(function () {
  "use strict";

  EditGroupTrainersSidebarCtrl.$inject = ['$scope', 'modalHelper', 'groupsResource', '$modal'];
  angular
    .module('trainerWebApp.controllers')
    .controller('EditGroupTrainersSidebarCtrl', EditGroupTrainersSidebarCtrl);

  function EditGroupTrainersSidebarCtrl($scope, modalHelper, groupsResource, $modal) {
    var storedGroupInfo = $scope.selectedGroup;
    var self = this;

    $scope.serverCallInProgress = false;

    $scope.select2GroupTrainers = storedGroupInfo.allRestrictedTrainers;
    var select2AllTrainers = [];
    var newGroupsTrainers = [];

    this.addTrainerToList = function (trainer) {
      $scope.groupTrainers.push({id: trainer.id, name: trainer.name, permissions: trainer.permissions});
      newGroupsTrainers.push(trainer.id);
      markDirty();
      if ($scope.forceCloseDropDown)
        $scope.forceCloseDropDown();
    };

    function allTrainersQuery(query) {
      query.callback({
        results: getAllResults(query.term)
      });
    }

    function getAllResults(term) {
      var results;

      //Add all user trainers to dropdown list
      select2AllTrainers = _.uniq(_.union($scope.select2GroupTrainers, storedGroupInfo.allTrainers), false, function (trainer) {
        return trainer.id;
      });

      if (term && term.length !== 0) {
        var termLower = term.toLowerCase();

        results = _.filter(select2AllTrainers, function (item) {
          return item.name.toLowerCase().indexOf(termLower) >= 0;
        });
      } else {
        results = select2AllTrainers;
      }

      var groupTrainerIds = _.pluck($scope.groupTrainers, 'id');

      return _.filter(results, function (item) {
        return !_.contains(groupTrainerIds, item.id);
      });
    }

    function getGroupPermissionsCount(trainerId) {
      return _.filter(storedGroupInfo.allRestrictedTrainers, function (trainer) {
        return trainer.id == trainerId;
      }).length;
    }

    $scope.selectTrainersOptions = {
      width: '100%',
      multiple: true,
      query: allTrainersQuery,
      minimumInputLength: 0,
      maximumInputLength: 40,
      allowClear: true,
      dropdownCssClass: "select2-dropdown-size-hack select2-short-dropdown"
    };

    $scope.groupTrainers = storedGroupInfo.groupTrainers;

    $scope.viewModel = {
      selectedTrainers: $scope.groupTrainers
    };

    $scope.selectGroupsOptions = {
      closeOnSelect: false,
      maximumInputLength: 40
    };

    $scope.cancelChanges = function () {
      clean();
      $scope.changeSidebar('pages/group/groupDetailSidebar.html');
    };

    $scope.applyChanges = function () {
      var trainerIds = _.pluck($scope.groupTrainers, 'id');

      $scope.serverCallInProgress = true;
      //$scope.showSpinner();
      groupsResource.updateGroupTrainers(storedGroupInfo.id, trainerIds, function (res) {
        $scope.refreshData();
        $scope.serverCallInProgress = false;
        $scope.manageGroupsEditors.editGroupTrainersSidebarDirty = false;
        newGroupsTrainers = [];
        $scope.changeSidebar('pages/group/groupDetailSidebar.html');
      });
      $scope.serverCallInProgress = false;
    };

    function clean() {
      $scope.manageGroupsEditors.editGroupTrainersSidebarDirty = false;
      $scope.serverCallInProgress = false;
    }

    function markDirty() {
      $scope.manageGroupsEditors.editGroupTrainersSidebarDirty = true;
    }

    $scope.canApplyChanges = function () {
      return $scope.manageGroupsEditors.editGroupTrainersSidebarDirty && !$scope.serverCallInProgress;
    };

    $scope.remove = function (trainer) {
      if (!~newGroupsTrainers.indexOf(trainer.id) && getGroupPermissionsCount(trainer.id) == 1) {
        $scope.selectedTrainer = trainer;
        $scope.forceCloseDropDown();

        var modalInstance = $modal.open({
          templateUrl: 'pages/modals/messageBox.html',
          controller: 'GroupRemoveRestrictionTrainerCtrl',
          scope: $scope
        });

        modalInstance.result.then(function () {
          removeTrainersFromList(trainer.id);
        });
        return;
      }

      removeTrainersFromList(trainer.id);
    };


    function removeTrainersFromList(trainerId) {
      $scope.groupTrainers = _.reject($scope.groupTrainers, function (u) {
        return u.id == trainerId;
      });
      newGroupsTrainers = _.reject(newGroupsTrainers, function (id) {
        return id == trainerId;
      });
      markDirty();
      if ($scope.forceCloseDropDown)
        $scope.forceCloseDropDown();
    }

    $scope.addTrainer = function (trainer) {
      if (trainer.groupRestriction) {
        self.addTrainerToList(trainer);
        return;
      }

      $scope.selectedTrainer = trainer;
      $scope.forceCloseDropDown();

      var modalInstance = $modal.open({
        templateUrl: 'pages/modals/messageBox.html',
        controller: 'GroupRestrictTrainerCtrl',
        scope: $scope
      });

      modalInstance.result.then(function () {
        self.addTrainerToList(trainer);
      });
    };

  }

})();
